import gql from "graphql-tag";

export const CREATE_ALL_AUTHORIZATION_BY_EXAMINER = gql`
  mutation createAllAuthorizationByExaminer($contractCodes: [String]!) {
    createAllAuthorizationByExaminer(contractCodes: $contractCodes)
  }
`;
